export default __webpack_public_path__ + "static/media/image-copy.3a74abdb.png";